import React from 'react';

function useToggle(defaultValue) {
  const [value, setValue] = React.useState(defaultValue);
  const handleValueChange = () => setValue(!value);
  return [value, handleValueChange];
}

export default useToggle;
